import layout from '../../../../variables/layouts';
const cardStyle = {
  card: {
    border: layout.mainPanel.paper.border,
    marginBottom: "30px",
    marginTop: "30px",
    borderRadius: "3px",
    color: layout.mainPanel.paper.color,
    background: layout.mainPanel.paper.backgroundColor,
    width: "100%",
    boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    fontSize: ".875rem",
  },
  cardPlain: {
    background: "transparent",
    boxShadow: "none"
  },
  cardProfile: {
    marginTop: "30px",
    textAlign: "center"
  },
  cardChart: {
    "& p": {
      marginTop: "0px",
      paddingTop: "0px"
    }
  }
};

export default cardStyle;
